import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex gap-7 max-h-fit overflow-hidden w-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("button", null, "Read more", -1)
const _hoisted_3 = { class: "h-5/6 flex flex-col-reverse" }
const _hoisted_4 = { class: "flex flex-wrap gap-2 py-2" }
const _hoisted_5 = {
  key: 0,
  class: "text-xl font-bold text-white"
}
const _hoisted_6 = { class: "text-sm font-normal" }
const _hoisted_7 = {
  key: 1,
  class: "text-xl font-bold"
}
const _hoisted_8 = { class: "text-sm font-normal" }

import { computed } from "vue"
  import { map, uniq } from "lodash"
  import { IonItem } from "@ionic/vue"
  // components
  import Avatar from "@/components/template/avatar.vue"
  import router from "@/router"

  // image
  interface EAAnswers {
    answer: string
    hide: boolean
    question: string
    topic: string
  }

  interface UserName {
    first_name: string
    last_name: string
    full_name: string
  }

  interface User {
    employment: object
    name: UserName
    photo: string
  }

  interface AnswerBody {
    answers: EAAnswers[]
    display_link: string
    associated_company: string
    answer_id: string
  }

  interface Company {
    logo: string
    name: string
    slug: string
    brand_color: string
  }

  interface AnswerDetails {
    user: User
    company: Company
    answer: AnswerBody
    newsfeed_id: string
  }

  interface Props {
    userAnswers: AnswerDetails
    likes: string[]
    shares: string[]
    post_id: string
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'EmployeeAmbassadorship',
  props: {
    userAnswers: null,
    likes: null,
    shares: null,
    post_id: null
  },
  setup(__props: any) {

const props = __props as {
    userAnswers: AnswerDetails
    likes: string[]
    shares: string[]
    post_id: string
  }

  

  const topics = computed(() => uniq(map(props.userAnswers.answer.answers, "topic")))

  const readMore = () => {
    localStorage.setItem("backLink", `${router.currentRoute.value.fullPath}`)
    router.push(`/workbean-world/employee-ambassadorship/${props.post_id}`)
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "bg-center bg-cover bg-no-repeat min-h-[469px] w-[330px] mx-auto rounded-base flex-shrink-0 relative px-2 py-4",
      style: _normalizeStyle({ 'background-image': `url(${__props.userAnswers.answer.display_link ? __props.userAnswers.answer.display_link : __props.userAnswers.company.logo})` })
    }, [
      _createVNode(_unref(IonItem), {
        class: "dark:text-white text-primary-black font-bold py-2 px-4 w-fit ml-auto rounded-2xl",
        onClick: readMore
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(topics), (item) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item,
              class: "px-[5px] py-2 text-white rounded-[5px] font-bold w-fit text-sm",
              style: _normalizeStyle({
              background: __props.userAnswers?.company?.brand_color ? __props.userAnswers?.company?.brand_color : '#7442C8',
            })
            }, _toDisplayString(item), 5))
          }), 128))
        ]),
        (__props.userAnswers.user)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
              _createTextVNode(_toDisplayString(__props.userAnswers.user.name.full_name) + " ", 1),
              _createElementVNode("p", _hoisted_6, _toDisplayString(__props.userAnswers?.user?.employment?.role), 1)
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_7, [
              _createTextVNode(_toDisplayString(__props.userAnswers.company.name) + " ambassador ", 1),
              _createElementVNode("p", _hoisted_8, _toDisplayString(__props.userAnswers.user ? __props.userAnswers.user.name.full_name : ""), 1)
            ]))
      ])
    ], 4)
  ]))
}
}

})